import { render, staticRenderFns } from "./NoteTab.vue?vue&type=template&id=3c5e9bfb&scoped=true&"
import script from "./NoteTab.vue?vue&type=script&lang=js&"
export * from "./NoteTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5e9bfb",
  null
  
)

export default component.exports